// extracted by mini-css-extract-plugin
export default {"gamePlayClassic":"Classic_gamePlayClassic__a9zAp","mainArea":"Classic_mainArea__QE-1X"};